<template>
	<v-row
		align="center"
		justify="center"
	>
		<v-col md="6">
			<v-card>
				<v-list
					dense
					class="pa-0"
				>
					<template v-for="(item, index) in items">
						<v-list-item
							:key="index"
							:to="{ name: item.name}"
						>
							<v-list-item-content>
								<v-list-item-title class="text-center">{{item.meta.label}}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-divider
							v-if="index + 1 < items.length"
							:key="index+'divider'"
						/>
					</template>
				</v-list>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import MunicipalityRoutes from '@/router/municipality'
export default {
	name: 'MainPage',
	data() {
		return {}
	},
	computed: {
		items() {
			return MunicipalityRoutes.children.filter(item => item.path !== '')
		}
	},
	mounted() {},
	methods: {}
}
</script>
